import React from 'react';
import useSearch from '../../../../util/search/useSearch';
import { H1 } from '../../../../@nitty';
import { Container } from '../../../styles';

const View = ({ title }) => {
    return (
        <Container>
            <H1>{title}</H1>
        </Container>
    );
};

export default View;
